var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "passwd_affix" }, [
    _c(
      "svg",
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "20",
          height: "20",
          viewBox: "0 0 20 20"
        }
      },
      [
        _c("path", {
          staticClass: "passwd_svg",
          attrs: {
            transform: "translate(0 2)",
            d:
              "M19.857,8.082 C17.684,12.666 14.401,14.972 9.995,14.972 C5.591,14.972 2.306,12.666 0.133,8.084 C-0.044,7.710 -0.044,7.274 0.133,6.902 C2.306,2.317 5.589,0.011 9.995,0.011 C14.399,0.011 17.684,2.317 19.857,6.900 C20.034,7.278 20.034,7.710 19.857,8.082 ZM9.995,1.664 C6.297,1.664 3.590,3.541 1.680,7.492 C3.590,11.443 6.297,13.320 9.995,13.320 C13.695,13.320 16.402,11.443 18.310,7.492 C16.400,3.541 13.693,1.664 9.995,1.664 ZM9.903,11.531 C7.675,11.531 5.869,9.722 5.869,7.492 C5.869,5.262 7.675,3.453 9.903,3.453 C12.132,3.453 13.938,5.262 13.938,7.492 C13.938,9.722 12.132,11.531 9.903,11.531 ZM9.903,4.922 C8.484,4.922 7.336,6.072 7.336,7.492 C7.336,8.912 8.484,10.062 9.903,10.062 C11.322,10.062 12.471,8.912 12.471,7.492 C12.471,6.072 11.322,4.922 9.903,4.922 Z"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }